import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=77e477ce&scoped=true"
import script from "./horizontal-nav.vue?vue&type=script&lang=js"
export * from "./horizontal-nav.vue?vue&type=script&lang=js"
import style0 from "./horizontal-nav.vue?vue&type=style&index=0&id=77e477ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e477ce",
  null
  
)

export default component.exports